import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'shr-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {
  @Input() controlId: string;
  @Input() readonly = false;
  @Input() label: string;
  @Input() form: FormGroup;
  @Input() ariaDescribedBy?: string;
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  private value = false;

  get checked() {
    return this.value;
  }

  @Input()
  set checked(value: boolean) {
    const newValue = !!value;
    if (this.value !== newValue) {
      this.value = newValue;
      this.checkedChange.emit(newValue);
    }
  }
  constructor(private elementRef: ElementRef) { }

  getCssClass(): string {
    return this.readonly ? 'no-pointer mb-0 readonly' : 'btn mb-0';
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();

      // Toggle via setter → this will automatically simulate the change event
      this.checked = !this.checked;
    }
  }
}
